import { RenaultAnimationSubactionDetailDTO, RenaultAnimationSubactionDetailSupervisorDTO, RenaultAnimationSubactionGoalMatrixDTO } from "./renault-animation-subaction-dto";
import { RenaultDistributorPvGroupDTO } from "./renault-distributor-pv-group";
import { DistributorParams } from "./shared-dto";

export interface RenaultAnimationActionDTO {
  IdAction: string;
  Status: boolean;
  Title: string;
  StartDate: Date;
  EndDate: Date;
  Amazon: boolean;
  ExtraDays?: number;
  HasExtraDaysAccess?: boolean;
}

export interface RenaultAnimationActionDetailDTO {
  IdAction: string | null;
  IsOpen: boolean;
  Title: string;
  StartDate: Date;
  EndDate: Date;
  RenaultAnimationSubactions: RenaultAnimationSubactionDetailDTO[];
  Amazon: boolean;
  ExtraDays?: number;
  HasExtraDaysAccess?: boolean;
}

export interface RenaultAnimationActionDetailSupervisorDTO {
  IdAction: string | null;
  IsOpen: boolean;
  Title: string;
  StartDate: Date;
  EndDate: Date;
  TotalUsers: number;
  TotalRemuneration: number;
  IdUser: string;
  UserName: string;
  RenaultAnimationSubactions: RenaultAnimationSubactionDetailSupervisorDTO[];
  RenaultAnimationSubactionsUser: RenaultAnimationSubactionDetailDTO[];
  Amazon: boolean;
}

export interface RenaultAnimationActionResultFilterDTO {
  IdAction: string;
  DistributorFilters: DistributorParams;
}

export class RenaultAnimationActionResultModel {
  Title: string;
  TotalRemuneration: number;
  Subactions: RenaultAnimationSubactionResultModel[];
}

export class RenaultAnimationSubactionResultModel {
  Title: string;
  TotalRemuneration: number;
  TotalUnits: number;
}

export interface RenaultAnimationActionGoalMatrixDTO {
  IdAction: string;
  Title: string;
  Subactions: RenaultAnimationSubactionGoalMatrixDTO[];
}

export class RenaultAnimationActionGoalMatrixGroupDTO {
  IdGroup: number;
  Group: string;
  Subactions: RenaultAnimationSubactionGoalMatrixDTO[];
  PvGroups: RenaultDistributorPvGroupDTO[];
}

export class RenaultAnimationActionGoalMatrixGlobalDTO {
  Action: string;
  Groups: RenaultAnimationActionGoalMatrixGroupDTO[];
}

export class RenaultAnimationActionRemuneration {
  Position: string;
  PercentValue: number;
}